"use client";

import React from "react";
import { ArrowRight, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurHeartForChange() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="179763" id="a-lifetime-of-exploration-and-giving-back" className="bg-background text-foreground relative flex min-h-[90vh] items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/hero_smiling_child.png" alt="Founders providing humanitarian aid" className="h-full w-full object-cover object-center" />
        {}
        <div className="absolute inset-0 bg-primary/30 mix-blend-multiply"></div>
      </div>

      {}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4af37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }}></div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center transition-all duration-1000 sm:px-6 lg:px-8 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        {}
        <Badge variant="secondary" className="mb-8 rounded-sm px-5 py-2 text-sm font-mono font-bold uppercase tracking-widest shadow-lg shadow-black/40 border-secondary/30">
          <Heart className="mr-2 h-4 w-4 fill-current text-secondary" />
          Our Philanthropy Fund
        </Badge>

        {}
        <h1 className="mb-10 max-w-5xl font-serif text-5xl font-semibold leading-tight text-secondary drop-shadow-2xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tight">
          A Lifetime of Exploration and Giving Back
        </h1>

        {}
        <div className="flex flex-col items-center justify-center gap-6 sm:flex-row sm:gap-8">
          <Button size="lg" className="group h-14 bg-primary text-primary-foreground rounded-sm px-8 text-lg font-mono font-semibold shadow-xl transition-all hover:scale-105 hover:bg-primary/90 hover:shadow-primary/20" asChild>
            <Link to="#">
              Our Mission
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button variant="ghost" size="lg" className="group relative h-14 border border-secondary/50 rounded-sm px-8 text-lg font-mono font-medium text-secondary transition-colors hover:bg-secondary/10 hover:text-secondary" asChild>
            <Link to="#">
              Support Growth
              {}
              <span className="absolute bottom-3 left-1/2 h-0.5 w-12 -translate-x-1/2 animate-pulse bg-secondary/60 transition-all duration-300 group-hover:w-20 group-hover:bg-secondary"></span>
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}